<section class="secondary-drawer-container d-flex align-items-center">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Snooze Recommendation</h5>
</section>

<mat-card class="d-inline-block w-100 float-start notifications recommendation-card">
    <div class="w-100 d-inline-block float-start mb-20">
        <h2 class="mb-0 font-poppins font-regular font-15 line-height-20">{{selectedAsset?.displayTitle}}</h2>
        <div class="gray-text font-12">
            <span>{{selectedAsset?.actionPerformDate| date:'dd MMM yyyy'}} at {{selectedAsset?.actionPerformDate |  date:'shortTime'}}</span>
        </div>
    </div>    
</mat-card>
<div class="d-flex w-100 flex-column">
    <h2 class="font-poppins font-regular font-14 line-height-20 mb-20">When would you like to be reminded about this recommendation again?</h2>
    <section>
        <mat-form-field  class="w-100" appearance="outline">
            <mat-label class="mb-20">Time period</mat-label>
            <mat-select [disabled]="!isSnoozeEnabled" [(value)]="selectedTimePeriod">
                <mat-option *ngFor="let t of filteredTimePeriod" [value]="t.id">
                <div class="tenant-info d-flex align-items-center">
                    <span>{{ t.name }}</span>
                </div>
                </mat-option>
  </mat-select>
        </mat-form-field>
    </section>
</div>
<div class="inner-drawer-actions">
    <button (click)="dismiss()" class="common-button light-gray mat-elevation-z0 ms-2"  mat-button mat-raised-button>Cancel</button>
    <button [disabled]="!isSnoozeEnabled" (click)="snooze()"  class="common-button black mat-elevation-z0 ms-2" mat-button mat-raised-button>Snooze</button>
</div>